var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerTrust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(-1213 -1322)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1213 1322)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "customer",
    transform: "translate(1223.285 1332.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(16.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M214.721,0a4.753,4.753,0,0,0-4.692,4.692,4.753,4.753,0,0,0,4.692,4.692,4.693,4.693,0,0,0,0-9.385Z",
    transform: "translate(-210.029)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(13.871 9.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M192.152,122a6.881,6.881,0,0,1-5.123,2.308,7.049,7.049,0,0,1-5.2-2.308,6.87,6.87,0,0,0-1.8,4.616v1.154a1.153,1.153,0,0,0,1.154,1.154H192.8a1.153,1.153,0,0,0,1.154-1.154v-1.154A6.87,6.87,0,0,0,192.152,122Z",
    transform: "translate(-180.029 -122)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(0.024 22.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M11.173,303.6,5.292,291.81A2.308,2.308,0,0,0,2.2,290.772l-1.537.761a1.155,1.155,0,0,0-.519,1.551L7.07,306.93a1.155,1.155,0,0,0,1.545.518l1.517-.752A2.308,2.308,0,0,0,11.173,303.6Z",
    transform: "translate(-0.024 -290.532)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(6.87 18.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M120.61,237.342a2.3,2.3,0,0,0-3.046.3l-6.308,7.754a2.789,2.789,0,0,1-1.708.738h-5.377a1.154,1.154,0,1,1,0-2.308h4.616a2.308,2.308,0,0,0,0-4.616H102.74c-.575,0-.862-.365-1.315-.762a8.029,8.029,0,0,0-7.163-1.754,8.418,8.418,0,0,0-3.543,1.769l-.034-.028-1.669,1.469,6.559,13.152h13.212a6.952,6.952,0,0,0,5.539-2.769l6.769-9.693A2.326,2.326,0,0,0,120.61,237.342Z",
    transform: "translate(-89.016 -236.479)",
    fill: "#fafafa"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTrust);
export default __webpack_public_path__ + "static/media/customer_trust.acf8d18dcebb1d60f292bbd1882fe194.svg";
export { ForwardRef as ReactComponent };